import { useContext } from "react";
import { LocaleContext } from "./App";
import { checkLanguageLevel, get_translation_objects } from "./util";
import { Language, LanguageLevel } from "./enums.mjs";
import { AddButton, DropdownMenu, DropdownMenuWithManualError, RemoveButton } from "./Common";
import "./LanguagesSelect.css";
import isoLangs from "./iso_langs.json"

export function LanguagesSelect(props) {
    const locale = useContext(LocaleContext);

    // Create the language translation list
    let [languageTransList, languageTransListInverse] = get_translation_objects("language", Language, locale);
    
    // Add the iso languages
    for(let l of isoLangs) {
        languageTransList[l[0]] = l[1];
        languageTransListInverse[l[1]] = l[0];
    }
    

    const [languageLevelTransList, languageLevelTransListInverse] = get_translation_objects("language_level", LanguageLevel, locale);
    const reducedLanguageLevelTransList = {...languageLevelTransList};
    delete reducedLanguageLevelTransList[LanguageLevel.INTERMEDIATE];

    let newLanguageTransList = {};

    for(let [key, val] of Object.entries(languageTransList)) {
        let found = false;

        for(let i = 0; i < props.languages.length; i++) {
            const l = props.languages[i]["language"];
    
            if(l == key) {
                found = true;
                break;
            }
        }

        if(!found) {
            newLanguageTransList[key] = val;
        }
    }


    function handleAddClick(e) {
        let newLanguages = [...props.languages, {"language": "", "language_level": ""}];
        props.onLanguagesChange(newLanguages);
    }

    function handleRemoveClick(idx) {
        let newLanguages = [...props.languages];
        newLanguages.splice(idx, 1);
        props.onLanguagesChange(newLanguages);
    }

    function onLanguageChange(value, index) {
        let newLanguages = [...props.languages];
        newLanguages[index]["language"] = value;
        props.onLanguagesChange(newLanguages);
    }

    function onLevelChange(value, index) {
        let newLanguages = [...props.languages];
        newLanguages[index]["language_level"] = value;
        props.onLanguagesChange(newLanguages);
    }

    let languages = [];

    for(let i = 0; i < props.languages.length; i++) {
        const l = props.languages[i]

        languages.push(
            <div className={"language_box" + (props.minimal ? " language_box_minimal" : "")}>
                <div className="language_box_hori language_box_hori_gap">
                    <DropdownMenu minimal={props.minimal} readOnly={props.readOnly} text={locale.msgs.LANGUAGE} value={languageTransList[l["language"]]}
                            onValueChange={(val) => onLanguageChange(languageTransListInverse[val], i)}
                            options={Object.values(newLanguageTransList)} />
                </div>
                
                <div className="language_box_hori">
                    <DropdownMenuWithManualError minimal={props.minimal} readOnly={props.readOnly} text={locale.msgs.LEVEL} value={languageLevelTransList[l["language_level"]]}
                            onValueChange={(val) => onLevelChange(languageLevelTransListInverse[val], i)}
                            options={Object.values(reducedLanguageLevelTransList)}
                            manualErrorText={!props.readOnly && !checkLanguageLevel(l["language_level"]) ? locale.msgs.INVALID_VALUE : ""} />
                </div>

                {
                    props.languages.length > 1 && !props.readOnly ?
                        <div className="right_remove_btn_box">
                            <RemoveButton onClick={() => handleRemoveClick(i)} visible={i !== 0} />
                        </div>
                    :
                        null
                }
                
            </div>
        );
    }

    return (
        <div className={"languages_select" + (props.readOnly ? " languages_select_readonly" : "")}>
            <div className={ "languages_box" + (props.minimal ? " languages_box_minimal" : "")}>
                {languages}
            </div>

            { props.languages.length < (Object.keys(languageTransList).length - 1) &&
                    props.languages.length < props.maxLanguages && !props.readOnly ?
                <div className="language_select_add_btn">
                    <AddButton onClick={handleAddClick} noMargin={true} />
                </div>
            : null
            }
        </div>
    )
}
